export default __webpack_public_path__ + "static/media/logo.d38cf3a7.svg";